import AbstractService from "./abstract.service"
import UsersTransformer, { baseUri } from "@/transformers/user.transformer"
import AssetsService from "./assets.service"
import { readFileAsBinary } from "./utils"

class UserService extends AbstractService {
  constructor() {
    super({ baseUri, transformer: UsersTransformer })
  }

  async updateAvatar(iri, file, locale) {
    let avatar = null
    if (file) {
      const binary = await readFileAsBinary(file)
      const asset = await AssetsService.upload(binary)
      avatar = asset.iri
    }

    return this.update(iri, { payload: { avatar, locale } })
  }

  createPassword(uuid, password) {
    if (!uuid) return

    return this.patch(`${this.baseUri}/password-create/${uuid}`, {
      needsAuth: true,
      payload: { password }
    })
  }
  updatePassword(uuid, payload) {
    if (!uuid) return

    return this.patch(`${this.baseUri}/password-update/${uuid}`, {
      needsAuth: true,
      payload
    })
  }
  resetPassword(uuid, payload) {
    if (!uuid) return

    return this.patch(`${this.baseUri}/password-reset/${uuid}`, {
      needsAuth: false,
      payload: {
        password: payload.password,
        resetRequest: `api/password-reset-requests/${payload.resetToken}`
      }
    })
  }
}

const userService = new UserService()
export default userService
